import { render, staticRenderFns } from "./album-card.vue?vue&type=template&id=57d39bd5&scoped=true&lang=pug&"
import script from "./album-card.vue?vue&type=script&lang=js&"
export * from "./album-card.vue?vue&type=script&lang=js&"
import style0 from "./album-card.vue?vue&type=style&index=0&id=57d39bd5&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d39bd5",
  null
  
)

export default component.exports